import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Backdrop, CircularProgress } from '@mui/material';
import Header from '../header';
import Footer from '../footer';
import CustomInput from '../../components/customInput';
import CustomButton from '../../components/customButton';
import { useSelector } from 'react-redux';
import { langSelector } from '../../store/langSlice';
import getEnvironement, { getLang } from '../../environnement';

export default function NousContacter({
  activeItem
}) {
  const [nomPrenom, setNomPrenom] = useState('');
  const [tel, setTel] = useState('');
  const [objet, setObjet] = useState('');
  const [message, setMessage] = useState('');

  const [nomPrenomError, setNomPrenomError] = useState('');
  const [telError, setTelError] = useState('');
  const [objetError, setObjetError] = useState('');
  const [messageError, setMessageError] = useState('');

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const lang = useSelector(langSelector);

  const sendMessage = async () => {
    const url = `${getEnvironement().API_URL}/messages`;
    const data = {
      lang,
      nomPrenom,
      tel,
      objet,
      message
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then(() => setOpenBackdrop(false))
      .then(() => toast.success(getLang(lang).nousContacter.messageSuccess))
      .then(() => {
        setNomPrenom('');
        setTel('');
        setObjet('');
        setMessage('');
        setNomPrenomError('');
        setTelError('');
        setObjetError('');
        setMessageError('');
      })
      .catch((err) => {
        console.log(err);
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          err.response.data.errors.nomPrenom && setNomPrenomError(err.response.data.errors.nomPrenom[0]);
          err.response.data.errors.tel && setTelError(err.response.data.errors.tel[0]);
          err.response.data.errors.objet && setObjetError(err.response.data.errors.objet[0]);
          err.response.data.errors.message && setMessageError(err.response.data.errors.message[0]);
        }
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <ToastContainer />
      <Backdrop
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          color: '#A31732',
        }}
        open={openBackdrop}
        onClick={() => setOpenBackdrop(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Header activeItem={activeItem} />
      <div className='3xl:flex 3xl:justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='3xl:w-[1200px] px-10 my-10'>
          <p className='font-inter text-primary font-medium text-2xl sm:text-3xl mb-6' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).nousContacter.nousContacter}</p>
          <CustomInput
            type='text'
            placeholder={getLang(lang).nousContacter.nomPrenom}
            value={nomPrenom}
            setValue={setNomPrenom}
            isError={nomPrenomError !== ''}
            error={nomPrenomError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).nousContacter.numeroTelephone}
            value={tel}
            setValue={setTel}
            isError={telError !== ''}
            error={telError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).nousContacter.objet}
            value={objet}
            setValue={setObjet}
            isError={objetError !== ''}
            error={objetError}
          />
          <CustomInput
            type='textarea'
            placeholder={getLang(lang).nousContacter.message}
            value={message}
            setValue={setMessage}
            isError={messageError !== ''}
            error={messageError}
          />
          <CustomButton
            value={getLang(lang).nousContacter.envoyer}
            handelClick={sendMessage}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
